export default "__VITE_ASSET__BTSyZ5SN__"